const reasonEvent = {
  ADD_REASON: 'ADD_REASON',
  EDIT_REASON: 'EDIT_REASON',
  DEL_REASON: 'DEL_REASON'
};

export default reasonEvent;